var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":true,"color":"#197f97","height":128,"width":128,"loader":"bars","backgroundColor":"#ffffff","opacity":0.5},on:{"update:active":function($event){_vm.isLoading=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }